/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable import/no-cycle */
import React from 'react';
import {Box, FrameworkImage, MusicTrackV2Player, MusicTrackV2Slider} from '..';

export const MusicNFTTrack = ({
  src,
  isPlaying,
  isMute,
  isLoading,
  duration,
  currentTime,
  setCurrentTime,
  toggleFullScreen,
  isFullScreen,
  audioPlayer,
  togglePlayPause,
  toggleMute,
  musicPlayerDisabled,
  isMobile,
}: any) => {
  return (
    <Box position="relative" width="100%" height={['', '100%']}>
      {src && !isMobile && (
        <img src={src} alt={src} style={{width: 'auto', height: '100%'}} />
      )}
      {src && isMobile && (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={src} alt={src} style={{width: '100%', height: 'auto'}} />
      )}
      <Box position="absolute" bottom="0px" width="100%">
        {/* <MusicTrackV2Slider
          isPlaying={isPlaying}
          duration={duration}
          currentTime={currentTime}
          setCurrentTime={setCurrentTime}
          audioPlayer={audioPlayer}
        /> */}
        {!musicPlayerDisabled ? (
          <MusicTrackV2Player
            isPlaying={isPlaying}
            isLoading={isLoading}
            duration={duration}
            currentTime={currentTime}
            togglePlayPause={togglePlayPause}
            isMute={isMute}
            toggleMute={toggleMute}
            fullPagePlayer={true}
            musicPlayerDisabled={musicPlayerDisabled}
            setCurrentTime={setCurrentTime}
            toggleFullScreen={toggleFullScreen}
            isFullScreen={isFullScreen}
            audioPlayer={audioPlayer}
          />
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};
